// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"8":"icu4x-2-2","211":"icu4x-2-1","626":"icu4x-2-0"}[chunkId] || chunkId) + "." + {"8":"629b1b93","41":"78f90fad","211":"985bdf33","319":"475b9a74","453":"f5e73427","626":"bb974897","689":"0909ba3f","746":"988b1cb6","772":"f834b918","883":"cc8a0e0e"}[chunkId] + ".chunk.js";
};